// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"675bebe8","787":"60a091cd","874":"8dd6756f","947":"56cb000e"}[chunkId] + ".chunk.js";
};